import React, { useState } from 'react';
import Header from '../component/Header';
import ChatWithAI from '../component/ChatWithAI';
import Sidebar from '../component/Sidebar';


const ChatAI = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => { 
        setIsSidebarOpen(!isSidebarOpen);
    };
 
    return (
        <div className='w-full bg-[#F9FAFB] instrument-sans-medium'>
            <div className='fixed w-full z-20'>
                <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='Chat'
                     />  
            </div>

            <div className={`pt-16 md:pt-20 w-full ${isSidebarOpen ? 'md:pt-20 w-full' : 'w-full'}`}>
                <div className={`${isSidebarOpen ? 'md:block z-50' : 'hidden  z-50'}`}>
                    <Sidebar />
                </div>
               
                <div className='h-full w-full lg:ml-[16.67%]'>
                 <ChatWithAI />
                </div>
            </div>
        </div>
    )
}

export default ChatAI
